export default "__VITE_ASSET__Dey7FtqX__"